import { useLocation as useLocationRRD} from "react-router-dom";
import { useFlags } from "hooks";

const useLocation = () => {
  const { pathname } = useLocationRRD()

  const { isCreatorsEnabled } = useFlags()

  const isCreators = isCreatorsEnabled && (pathname === '/creators' || pathname.includes('/creators/'))

  const isPlay = !isCreators

  const isSeries = pathname === '/series' || pathname.includes('/series/')
  const isCommunity = pathname === '/community' || pathname.includes('/community/')
  const isSearch = pathname === '/search'

  const isFlixx = pathname === '/flixx'
  const isBeCreator = pathname === '/be-a-creator'
  const isFaqs = pathname === '/faqs'

  return {
    isCreators,
    isPlay,
    isSeries,
    isCommunity,
    isSearch,
    isFlixx,
    isBeCreator,
    isFaqs,
    pathname
  };
};

export default useLocation;